import React from 'react';
import { Client, HydrationProvider } from 'react-hydration-provider';
import { useInView } from 'react-intersection-observer';
import ReactPlayer from 'react-player';

import * as styles from './RichTextArticle.module.scss';

const YouTubeVideo = ({ videoUrl }) => {
  const { ref: containerRef, inView: isVisible } = useInView({
    threshold: 0,
    triggerOnce: false,
    rootMargin: '150px',
  });

  return (
    <div className={styles.playerWrapper} ref={containerRef}>
      <HydrationProvider>
        <Client>
          {isVisible && (
            <ReactPlayer
              className={[styles.reactPlayer, styles.fadeIn].join(' ')}
              controls={true}
              width="100%"
              height="100%"
              url={videoUrl}
              src={videoUrl}
            />
          )}
        </Client>
      </HydrationProvider>
    </div>
  );
};

export default YouTubeVideo;
